module.exports = {
  LifeCulture:'Life & Culture',
  LifeCultureTips1:'Explore everyday Japanese life and culture with visuals',
  LifeCultureTips2:'PinYin Sounds & Tones',
  Grammar:'Grammar',
  GrammarTips1:'Learn essential Japanese grammar for daily life',
  Conversation:'Conversation',
  ConversationTips1:'Learn through short,easy conversation videos',
  ConversationTips2:'Speaking Video List',
  '300 Sentences':'300 Sentences',
  '300SentencesTips1':'300 useful Chinese sentences for life, study, and travel.',
  'Basic Hiragana':'Basic Hiragana',
  'Basic Chinese Hiragana':'Basic Chinese Hiragana',
  'BasicHiraganaTips1':'Test your tones pronunciation, and pinyin.',
  HiraganaTips:'Not unlocked yet',
  'Learn':'Learn',
  'Watch':'Watch',
  'Recommended':'Recommended',
  NoGameList:'No Basic Hiragana!',
  "Sample Sentence":"Sample Sentence",
  "Ques No":"Ques No",
  "Correct Answer":"Correct Answer",
  "Your Answer":"Your Answer",
  "Your Result":"Your Result",
  "Final Result":"Final Result",
  "Previous":"Previous",
  "Next":"Next",
  "Try Again":"Try Again",
  "Next Level":"Next Level",
  "Profile":"Profile",
  "Current Hiragana Level":"Current Hiragana Level",
  language:"Language Select",
  Unsucscribe:"Unsucscribe",
  back:"Back",
  Replay:"Repaly",
  English:"English",
  Japanese:"Japanese",
  Roma_ji:"Roma-ji",
  loginTips:"Enter a phone number",
  subscribe:'Subscribe',
  FAQ:"FAQ",
  TC:"T&C",
  getCode:"Resend",
  register:"Register",
  phoneNumber:"Phone Number",
  Daily:"Daily",
  Weekly:"Weekly",
  pleaseWait:"Please wait",
  loading:"loading",
  Submit:"Submit",
  Confirm:"Confirm",
  OK:"OK",
  change:"Change",
  Myanmar:"Myanmar",
  Copyright:"© 2025 All Rights Reserved.",
  select_level:"Start Review",
  select_level_tip1:"Start Now",
  select_level_tip2:"Skip this",
  level_1_title:"Your Journey Starts Here",
  level_1_tip:"You're at the LifeCulture Level.Perfect for building a strong foundationin the language.",
  level_1_btn:"Begin the Journey",
  level_2_title:"Great Progress!",
  level_2_tip:"You've reached the Grammar LevelTime to improve conversations,grammar, and fluency.",
  level_2_btn:"Keep Going",
  level_3_title:"IMpressive Skills!",
  level_3_tip:"You're at the Conversation Level.Get ready to master native-like speakingand comprehension.",
  level_3_btn:"Start Mastery",
  level_again:"Re-rating",
  current_level:"Current Level",
  Re_admission:"Re-admission Testing",
  Re_testing:"Re-Testing",
  Grammar_tips:"Please complete the LifeCulture course first",
  Conversation_tips:"Please complete the Grammar course first",
  in_process:"In Process",
  no_start:"Not Started",
  finished:"Finished",
  books:"Books",
  guidance:"GUIDANCE",
  test_level_tip:"Take a short review to know your language level.",
  LifeCulture_guidance_title:"Welcome to the LifeCulture class",
  LifeCulture_guidance_tip:"We'll start with Pinyin and guide you step by step.Once you complete the Pinyin course,more exciting lessons will be automatically unlocked for you!" ,
  Grammar_guidance_title:"Welcome to the Grammar class",
  Grammar_guidance_tip:"Don't worry, you can take it step by step.By completing all the lessons, you'll unlock even more interesting content. Keep it up!" ,
  advance_guidance_title:"Welcome to the advance class",
  advance_guidance_tip:"We've unlocked all the courses for you.Enjoy them to the fullest!" ,
  book_title:"Books Suitable" ,
  book_tip:"Books suitable for all levels, designed to be easy to learn and enjoy!" ,
  load_book:"Loading book content...",
  load_book_failed:"Failed to load book content",
  reload:"Reload",
  copyLink:"copyLink",
  downTips1:'Please copy the link into browser and download.',
  CopySucceeded:'Copy Succeeded',
  CopyFailed:'Copy Failed',
  home:'HOME',
  Select_Topics:'Select Topics',
  Select_Can_do:'Select Can-do',
  Practice:'Practice',
  Back:'Back',
  NEXT_STEP:'NEXT STEP',
  Challenge:'Challenge',
  Kanji:"Kanji",
  KanjiTips1:"Master key characters for daily life topics",
  Hiragana:"Hiragana",
  HiraganaTips1:"Learn basic hiragana for reading,writing,and pronunciation",
  katakana:"Katakana",
  katakanaTips1:"Master katakana for reading,writing,and pronunciation",
  Lessons:"Lessons",
  Key_phrase:"Key phrase",
  Scripts:"Scripts",
  grammar_tips:"Grammar tips",
  Topic:"Topic",
  Detail:"Detail",
  ANIMATION:"ANIMATION",
  MEMORY_HINT:"MEMORY HINT",
  EXAMPLES:"EXAMPLES",
  Choose_the:"Choose the reading for the",
  underlined:"underlined",
  word:"word",
  Answer:"Answer",
  VOCABULARIES:"VOCABULARIES",
  Katakana_Practice:"Katakana Practice",
  Katakana_tip_1:"Listen to the pronunciation",
  Katakana_tip_2:"and choose the Katakana..",
  Click_to_listen:"Click to listen",
  Hiragana_Practice:"Hiragana Practice",
  Hiragana_tip_2:"and choose the hiragana..",
  Close:"Close",
  Choose_Lesson:"Choose a Lesson",
  Lesson:"Lesson",
  Skit:"Skit",
  Video:"Video",
  Listen:"Listen",
  Download:"Download",
  select_pick_tip:"Pick a language and start today!",
  Selected:"Selected",
  Beginner:'Beginner',
  Intermediate:'Intermediate',
  Advanced:'Advanced',
  sharePanelTitle:'Share with friends',
  sharePanelTips:'Choose a platform below and send your invite link directly.',
  shareMore:'More Options',
  referralTips1:"I found something interesting and wanted to share it with you. Come and join me",
}



// WEBPACK FOOTER //
// ./src/assets/i18n/en.js